var _path, _path2, _mask, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7366 0.761748H10.0846C8.00465 0.753748 6.30065 2.41075 6.25065 4.49075V15.2277C6.20565 17.3297 7.87365 19.0697 9.97465 19.1147C10.0116 19.1147 10.0486 19.1157 10.0846 19.1147H18.0726C20.1626 19.0407 21.8146 17.3187 21.8026 15.2277V6.03775L16.7366 0.761748Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4749 0.75V3.659C16.4749 5.079 17.6239 6.23 19.0439 6.234H21.7979",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_14_3387",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.5V13V13.5Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5V15.5H8V13.5H4ZM8 13V11H4V13H8ZM8 13.5V13H4V13.5H8Z",
    fill: "white",
    mask: "url(#path-3-inside-1_14_3387)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6613 12.9297H1.62134",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4636 15.1172L12.8186 12.7722L10.4636 10.4272",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.6f031099cae3f89e93d660130a3b1c22.svg";
export { ForwardRef as ReactComponent };